'use client';
import { jsx } from 'react/jsx-runtime';
import { useOverlayTrigger } from '@react-aria/overlays';
import { useOverlayTriggerState } from '@react-stately/overlays';
import t from 'prop-types';
import { useRef, useMemo } from 'react';
import { SwanPopoverContextProvider } from './popover.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useModeExtractor } from '../../hooks/use-mode-extractor/index.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { RenderComp } from '../core/render-comp.component.js';

let v = {
    position: t.oneOf([
        'top',
        'right',
        'bottom',
        'left'
    ])
}, d = Object.keys(v);
const Popover = renderWithRef('Popover', v, (t, i)=>{
    useComponentStylesLoaded('Popover', SWAN_STYLE_KEY_MAP.popover);
    let { position: v = 'top', children: u } = t, y = useRef(null), h = assignRefs(i, y), P = useRef(null), x = useOverlayTriggerState({}), g = useModeExtractor(y, x.isOpen), { overlayProps: j, triggerProps: k } = useOverlayTrigger({
        type: 'dialog'
    }, x, P);
    return jsx(SwanPopoverContextProvider, {
        value: useMemo(()=>({
                modes: g,
                popoverRef: y,
                triggerRef: P,
                overlayState: x,
                overlayProps: j,
                triggerProps: k,
                popoverPlacement: null != v ? v : 'top'
            }), [
            P,
            y,
            x,
            j,
            k,
            v,
            g
        ]),
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: h,
            classNames: [
                'swan-popover-container'
            ],
            props: t,
            propKeysToRemove: d,
            children: u
        })
    });
});

export { Popover };
